import ApiBase from '@/api/base';

export default {
  getSendgridApiKeys() {
    return ApiBase.get(`/admin/sendgrid_api_keys`);
  },
};
